import { dropdownMenu } from '@atoms/dropdown-menu';

export const navAnonymousDesktop = () => {
  dropdownMenu('anonymous');
  document.querySelector('.nav-anonymous-desktop')?.setAttribute('data-ready', 'true');
};
